import { StyledVideoActivity } from './VideoActivity.styled';
import useVideoActivity from './useVideoActivity.hook';
import VideoPlayer from '@/shared/Players/VideoPlayer/VideoPlayer';
import { useContext, useRef } from 'react';
import useMediaActivityProgress from '../SimpleMediaActivities/useMediaActivityProgress';
import AnimatedStars from '@/shared/StudentPage/StudentPageTopbar/GamificationScoreBoard/AnimatedStars/AnimatedStars';
import { ANCHOR } from '@/modules/dom/getElementCoordinates';
import { StudentContext } from '@/shared/StudentContext/StudentContext';
import { GlobalContext } from '@/shared/GlobalContext/GlobalContext';
import useActivityAnalytics from '@/shared/PlausibleAnalytics/useActivityAnalytics.hook';

export default function VideoActivity({
  activity,
  taskProgressActions,
  demoMode,
}) {
  const playerRef = useRef(null);
  const { state: progressState, actions: progressAPIActions } =
    useMediaActivityProgress({
      activity,
      taskProgressActions,
      playerRef,
    });

  const { state: videoState } = useVideoActivity({
    activity,
    demoMode,
  });
  const { actions: seoActions } = useActivityAnalytics({ activity });

  const state = { ...videoState, ...progressState };

  const globalContext = useContext(GlobalContext);
  const studentContext = useContext(StudentContext);
  const canIncreasePlaybackRate = globalContext.state.user?.student
    ? studentContext.state.teacherPreferences?.studentsCanIncreasePlaybackRate
    : true;

  return (
    <>
      <StyledVideoActivity ratio={16 / 9}>
        {state.urls?.length && (
          <VideoPlayer
            urls={state.urls}
            posterUrl={state.posterUrl}
            noSeek={state.noSeek}
            onReady={progressAPIActions.onReady}
            onStart={() => {
              progressAPIActions.onStart();
              seoActions.onStart();
            }}
            onProgress={(progressData) => {
              progressAPIActions.onProgress(progressData);
              seoActions.onMediaProgress({ progressData });
            }}
            onRestart={() => {
              progressAPIActions.onRestart();
              seoActions.reset();
              seoActions.onStart();
            }}
            progressInterval={state.activityProgressInterval}
            canIncreasePlaybackRate={
              !taskProgressActions || canIncreasePlaybackRate
            }
            animatedStars={
              <AnimatedStars
                originSelector=".ant-progress-success-bg"
                originAnchor={ANCHOR.RIGHT}
              />
            }
          />
        )}
      </StyledVideoActivity>
    </>
  );
}
